export default __webpack_public_path__ + "static/header-bg-6ab2e11f46ee680016f13840c44f128f.webp";